module.exports = __webpack_public_path__ + "static/img/profile.1e9d06ce.png";